import { useEffect, useRef } from "react";

const COUNT = 80;
const COLORS = ["255, 85, 0", "255, 85, 0", "20, 184, 166"];

function canUse() {
  return typeof window !== "undefined"
    && window.matchMedia("(pointer: fine)").matches
    && !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

export function HeroParticles() {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas || !canUse()) return;
    const ctx = canvas.getContext("2d");
    const parent = canvas.parentElement;
    const mouse = { x: -9999, y: -9999 };
    let w = 0, h = 0, raf, parts = [];

    const resize = () => {
      w = canvas.width = parent.clientWidth;
      h = canvas.height = parent.clientHeight;
      parts = Array.from({ length: COUNT }, () => {
        const x = Math.random() * w, y = Math.random() * h;
        return { x, y, ox: x, oy: y, vx: (Math.random() - 0.5) * 0.3, vy: (Math.random() - 0.5) * 0.3, r: 1 + Math.random() * 1.8, c: COLORS[Math.floor(Math.random() * COLORS.length)], a: 0.25 + Math.random() * 0.45 };
      });
    };
    const onMove = (e) => { const r = parent.getBoundingClientRect(); mouse.x = e.clientX - r.left; mouse.y = e.clientY - r.top; };
    const onLeave = () => { mouse.x = -9999; mouse.y = -9999; };

    const tick = () => {
      ctx.clearRect(0, 0, w, h);
      for (const p of parts) {
        p.ox += p.vx; p.oy += p.vy;
        if (p.ox < 0 || p.ox > w) p.vx *= -1;
        if (p.oy < 0 || p.oy > h) p.vy *= -1;
        const dx = p.x - mouse.x, dy = p.y - mouse.y, d = Math.hypot(dx, dy);
        if (d > 0 && d < 140) { const f = (140 - d) / 140 * 6; p.x += (dx / d) * f; p.y += (dy / d) * f; }
        p.x += (p.ox - p.x) * 0.04; p.y += (p.oy - p.y) * 0.04;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(${p.c}, ${p.a})`; ctx.fill();
      }
      raf = requestAnimationFrame(tick);
    };

    resize();
    const ro = new ResizeObserver(resize);
    ro.observe(parent);
    parent.addEventListener("mousemove", onMove, { passive: true });
    parent.addEventListener("mouseleave", onLeave);
    raf = requestAnimationFrame(tick);
    return () => { cancelAnimationFrame(raf); ro.disconnect(); parent.removeEventListener("mousemove", onMove); parent.removeEventListener("mouseleave", onLeave); };
  }, []);

  return <canvas ref={ref} className="pointer-events-none absolute inset-0 hidden md:block" aria-hidden="true" data-testid="hero-particles" />;
}
